export default __webpack_public_path__ + "static/media/american-express.c3a15d7b.svg";